module.exports = "<img src=\"/assets/images/thumb/resto/terrasse.jpg\" alt=\"terrasse loup Gourmands\" class=\"terrasse\" />\n<img src=\"/assets/images/thumb/resto/carte.jpg\" alt=\"carte de visite\" class=\"visit-card\" />\n<p>\n  Au coeur du village remarquable de Cossé en Champagne, les Loups Gourmands vous accueillent tous les jours.\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/accueil-gourmands/accueil-gourmands.component.html
// module id = 576
// module chunks = 1